import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import type { TUPDRSVOption } from 'neuro-schemas/updrs_v';
import { arrayOfAll } from 'neuro-utils';

export const opts = arrayOfAll.options<TUPDRSVOption>()([0, 1, 1.5, 2, 2.5, 3, 4, 5]);

export const optFormatter = (n: number | string): React.JSX.Element => <FormattedMessage id={'updrs.opts.v.' + n} />;
